import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Catalog, RecommandationParameters, RecommandationProduct, UseCatalogOptions } from './Catalog.interface';
import { fetchCatalog, fetchRecommandation } from './Catalog.endpoint';
import { CallbackQueryOptions } from '@axa-fr-axion/user-journey-services';
import { getReactQueryRetryFnc } from 'test-utils';
import {
    reactQueryRetry,
} from '@axa-fr-axion/restful';

export const useCatalog = (options?: UseCatalogOptions): UseQueryResult<Catalog> =>
    useQuery(
        [ 'catalog' ],
        () => fetchCatalog(),
        {
            onError: options?.onTechnicalError,
            retry: getReactQueryRetryFnc(reactQueryRetry),
        },
    );

export const useCatalogRecommandation = (
    data: RecommandationParameters,
    options?: CallbackQueryOptions<RecommandationProduct>
): UseQueryResult<RecommandationProduct> =>
    useQuery<RecommandationProduct>(
        [ 'catalogRecommandation', data.codeSector ],
        () => fetchRecommandation(data),
        {
            onSuccess: options?.onSuccess,
            onError: options?.onTechnicalError,
        },
    );
